<template>
	<div class="content-wapper">

		<el-row class="navigation">
			<el-col align="left">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '' }">当前位置:</el-breadcrumb-item>
					<el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
					<el-breadcrumb-item :to="{ path: '' }">NQI服务</el-breadcrumb-item>
					<el-breadcrumb-item>质量及品牌</el-breadcrumb-item>
				</el-breadcrumb>
			</el-col>
		</el-row>

		<el-row :gutter="10">
			<el-col :span="6">
				<el-row class="left-img">
					<img src="@/assets/images/zltszhfw/zlypp/menu_banner.jpg" />
				</el-row>
				<el-row class="menu-box">
					<div v-for="(item, index) in menuList" :key="item.name">
						<div class="menu-level1" :class="{active1:isActive==item.name}" @click="changeMenu(item.name)">
							{{item.name}}
							<span :class="isCollapse==item.name?menuIconDown:menuIcon" ><i class="el-icon-arrow-right"></i></span>
						</div>
						<div v-show="isCollapse==item.name">
							<el-row :gutter="0">
								<el-col style="margin-bottom: 5px;text-align: left;" :span="12"
									v-for="(itemchild, index) in item.labels" :key="itemchild.code">
									<span @click="changeMenu2(item.name,itemchild.code,itemchild.label,itemchild.url)"
										class="menu-level2 "
										:class="{active2:isActive2==itemchild.code}">{{itemchild.label}}
									</span>
								</el-col>
							</el-row>
						</div>
					</div>
				</el-row>
			</el-col>
			<el-col :span="18" class="right-box">
				<!-- 通知公告 -->
				<el-row class="right-box-row" style="min-height: 430px;" v-show="isShow=='0101'">
					<el-row class="right-box-row-title">
						{{tableTitle}}
					</el-row>
					<el-form :model="ppsbtzggQueryParams" ref="queryForm" :inline="true" style="margin-top: 10px;">
						<el-row class="right-box-row-title">
							<el-col :span="20">
								<el-form-item>
									<el-input v-model="ppsbtzggQueryParams.title"
											  placeholder="请输入标题" clearable size="small" />
								</el-form-item><el-button type="primary" style="margin-top: 2px" size="small" @click="getPpsbtzggList">检 索</el-button>
							</el-col>
						</el-row>
					</el-form>
					<el-table v-loading="ppsbtzggLoading" :data="ppsbTzggList" :show-header="false" tooltip-effect="light">
						<el-table-column align="left" :show-overflow-tooltip="true" prop="title" class-name="title">
							<template slot-scope="scope">
								<span @click="openPpsbTzggDetail(scope.row)">{{ scope.row.title }}</span>
							</template>
						</el-table-column>
						<el-table-column align="center" prop="fbTime" width="180">
							<template slot-scope="scope">
								<span>{{ parseTime(scope.row.fbTime, '{y}-{m}-{d}') }}</span>
							</template>
						</el-table-column>
					</el-table>
					<pagination v-show="ppsbtzggTotal>0" :total="ppsbtzggTotal" :page.sync="ppsbtzggQueryParams.pageNum"
								:limit.sync="ppsbtzggQueryParams.pageSize" @pagination="getPpsbtzggList" />
				</el-row>

				<!-- 质量奖 -->
				<el-row class="right-box-row" style="min-height: 430px;" v-show="isShow=='0401'">
					<el-row class="right-box-row-title">
						{{tableTitle}}
					</el-row>
					<el-form :model="zljQueryParams" ref="queryForm" :inline="true" style="margin-top: 10px;">
						<el-row class="right-box-row-title">
							<el-col :span="20">
								<el-form-item>
									<el-input v-model="zljQueryParams.zljName"
											  placeholder="请输入质量奖名称" clearable size="small" />
								</el-form-item>
								<el-button type="primary" style="margin-top: 2px" size="small" @click="getZljList">检 索</el-button>
							</el-col>
						</el-row>
					</el-form>
					<el-table v-loading="zljLoading" :data="zljList" tooltip-effect="light">
						<el-table-column align="center" label="获奖名称" width="100">
							<template slot-scope="scope">
								<el-tag>质量奖</el-tag>
							</template>
						</el-table-column>
						<el-table-column label="质量奖名称" align="center" prop="zljName" :show-overflow-tooltip="true"/>
						<el-table-column label="组织名称" align="center" prop="deptName" />
						<el-table-column label="区域" align="center" prop="region" />
						<el-table-column label="获奖年份" align="center" prop="awardYear" />
					</el-table>
					<pagination v-show="zljTotal>0" :total="zljTotal" :page.sync="zljQueryParams.pageNum"
								:limit.sync="zljQueryParams.pageSize" @pagination="getZljList" />
				</el-row>

				<!-- 高端品牌培育企业 -->
				<el-row class="right-box-row" style="min-height: 430px;" v-show="isShow=='0402'">
					<el-row class="right-box-row-title">
						{{tableTitle}}
					</el-row>
					<el-form :model="gdpyQueryParams" ref="queryForm" :inline="true" style="margin-top: 10px;">
						<el-row class="right-box-row-title">
							<el-col :span="20">
								<el-form-item>
									<el-input v-model="gdpyQueryParams.entname"
											  placeholder="请输入企业名称" clearable size="small" />
								</el-form-item>
								<el-button type="primary" style="margin-top: 2px" size="small" @click="getGdpyList">检 索</el-button>
							</el-col>
						</el-row>
					</el-form>
					<el-table v-loading="gdpyLoading" :data="gdpyList" tooltip-effect="light">
						<el-table-column align="center" prop="type" label="类型" width="100">
							<template slot-scope="scope">
								<el-tag>
									{{typeFormat(scope.row.type,'')}}
								</el-tag>
							</template>
						</el-table-column>
						<el-table-column label="企业名称" align="center" prop="entname" :show-overflow-tooltip="true"/>
						<el-table-column label="区域" align="center" prop="region" />
					</el-table>
					<pagination v-show="gdpyTotal>0" :total="gdpyTotal" :page.sync="gdpyQueryParams.pageNum"
								:limit.sync="gdpyQueryParams.pageSize" @pagination="getGdpyList" />
				</el-row>

				<!-- 认定优质基地 -->
				<el-row class="right-box-row" style="min-height: 430px;" v-show="isShow=='0403'">
					<el-row class="right-box-row-title">
						{{tableTitle}}
					</el-row>
					<el-form :model="rdyzjdQueryParams" ref="queryForm" :inline="true" style="margin-top: 10px;">
						<el-row class="right-box-row-title">
							<el-col :span="20">
								<el-form-item>
									<el-input v-model="rdyzjdQueryParams.ltggEntname"
											  placeholder="请输入龙头骨干企业" clearable size="small" />
								</el-form-item>
								<el-button type="primary" style="margin-top: 2px" size="small" @click="getRdyzjdList">检 索</el-button>
							</el-col>
						</el-row>
					</el-form>
					<el-table v-loading="rdyzjdLoading" :data="rdyzjdList" tooltip-effect="light">
						<el-table-column align="center" prop="type" label="行业类别" width="100">
							<template slot-scope="scope">
								<el-tag>
									{{typeFormat(scope.row.type,'')}}
								</el-tag>
							</template>
						</el-table-column>
						<el-table-column label="基地名称" align="center" prop="jdname" :show-overflow-tooltip="true" :width="100"/>
						<el-table-column label="区域" align="center" prop="region" :show-overflow-tooltip="true"/>
						<el-table-column label="申报主体" align="center" prop="declarationSubject" :show-overflow-tooltip="true"/>
						<el-table-column label="取得认定称号年度" align="center" prop="affirmYear" width="160" :show-overflow-tooltip="true"/>
						<el-table-column label="龙头骨干企业" align="center" prop="ltggEntname" :show-overflow-tooltip="true"/>
					</el-table>
					<pagination v-show="rdyzjdTotal>0" :total="rdyzjdTotal" :page.sync="rdyzjdQueryParams.pageNum"
								:limit.sync="rdyzjdQueryParams.pageSize" @pagination="getRdyzjdList" />
				</el-row>

				<!-- 创建优质基地 -->
				<el-row class="right-box-row" style="min-height: 430px;" v-show="isShow=='0404'">
					<el-row class="right-box-row-title">
						{{tableTitle}}
					</el-row>
					<el-form :model="cjyzjdQueryParams" ref="queryForm" :inline="true" style="margin-top: 10px;">
						<el-row class="right-box-row-title">
							<el-col :span="20">
								<el-form-item>
									<el-input v-model="cjyzjdQueryParams.ltggEntname"
											  placeholder="请输入龙头骨干企业" clearable size="small" />
								</el-form-item>
								<el-button type="primary" style="margin-top: 2px" size="small" @click="getCjyzjdList">检 索</el-button>
							</el-col>
						</el-row>
					</el-form>
					<el-table v-loading="cjyzjdLoading" :data="cjyzjdList" tooltip-effect="light">
						<el-table-column align="center" prop="type" label="类型" width="100">
							<template slot-scope="scope">
								<el-tag>
									{{typeFormat(scope.row.type,'')}}
								</el-tag>
							</template>
						</el-table-column>
						<el-table-column label="基地名称" align="center" prop="jdname" :show-overflow-tooltip="true"/>
						<el-table-column label="区域" align="center" prop="region" :show-overflow-tooltip="true"/>
						<el-table-column label="取得创建称号年度" align="center" prop="createYear" :show-overflow-tooltip="true"/>
						<el-table-column label="龙头骨干企业名称" align="center" prop="ltggEntname" :show-overflow-tooltip="true"/>
					</el-table>
					<pagination v-show="cjyzjdTotal>0" :total="cjyzjdTotal" :page.sync="cjyzjdQueryParams.pageNum"
								:limit.sync="cjyzjdQueryParams.pageSize" @pagination="getCjyzjdList" />
				</el-row>

        <el-row class="right-box-row" style="min-height: 1000px;" v-if="isShow=='0503'">
          <el-row class="right-box-row-title">
            {{tableTitle}}
          </el-row>
          <el-form ref="form" :model="form" :rules="rules" label-width="150px" style="margin-top: 10px;">
            <el-row>
              <el-col :span="12">
                <el-form-item label="联系人" prop="linkUser">
                  <el-input v-model="form.linkUser" placeholder="请输入联系人" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系方式" prop="linkWay">
                  <el-input v-model="form.linkWay" placeholder="请输入联系方式" />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="线上商城地址" prop="onlineAddress">
                  <el-input v-model="form.onlineAddress" placeholder="请输入线上商城地址" />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="线下商城地址" prop="offlineAddress">
                  <el-autocomplete
                      class="inline-input"
                      style="width: 100%;"
                      v-model="form.offlineAddress"
                      :fetch-suggestions="querySearch"
                      placeholder="请输入线下商城地址"
                      @select="handleSelect"
                  ></el-autocomplete>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="产品图片" prop="photoPath">
                  <image-upload v-model="form.photoPath"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="短视频介绍" prop="videoPath">
                  <el-row v-if="isShow=='0503'" >
                    <attachment-single-module v-if="isShow=='0503'"
                                              :module="upload1.module"
                                              :businessid="form.videoPath"
                                              :typeName="upload1.typeName"
                                              :editAble="upload1.editAble"
                                              :accept="upload1.accept"
                                              :isReturn="upload1.isReturn">

                    </attachment-single-module>
                  </el-row>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="申报产品(服务)类别" prop="selectList">
                  <el-cascader
                      style="width: 100%;"
                      v-model="form.selectList"
                      :options="lmglOptions"
                      :props="lmglProps"
                      emitPath="true"
                      clearable>
                    <template slot-scope="{ node, data }">
                      <span>{{ data.lmName }}</span>
                      <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
                    </template>
                  </el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="企业和产品图文介绍" prop="entProductInstoduction">
                  <Editor v-model="form.entProductInstoduction" :min-height="192"/>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div style="margin-top: 50px;">
            <el-button type="primary" @click="submitForm">确 定</el-button>
          </div>
        </el-row>

        <el-row class="right-box-row" style="min-height: 500px;" v-if="isShow=='0504'">
          <el-row class="right-box-row-title">
            {{tableTitle}}
          </el-row>
          <el-form ref="form1" :model="form1" :rules="rules1" label-width="130px"  style="margin-top: 10px;">
            <el-row>
              <el-col :span="12">
                <el-form-item label="申请人/企业名称" prop="sqName">
                  <el-input v-model="form1.sqName" placeholder="请输入申请人/企业名称" disabled/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="所属区市" prop="region">
                  <el-input v-model="form1.region" placeholder="请输入所属区市" style="width:100%;"disabled/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="申请类型" prop="sqType">
                  <el-select v-model="form1.sqType" placeholder="请选择申请类型" style="width:100%;" disabled>
                    <el-option label="请选择申请类型"
                               v-for="item in sbTypeList"
                               :key="item.dictValue"
                               :value="item.dictValue"
                               :label="item.dictLabel"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系人" prop="linkUser">
                  <el-input v-model="form1.linkUser" placeholder="请输入联系人" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系方式" prop="linkWay">
                  <el-input v-model="form1.linkWay" placeholder="请输入联系方式" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="申请表" prop="sqTable">
                  <el-row v-if="isShow=='0504'" >
                    <attachment-single-module v-if="isShow=='0504'"
                                              :module="upload2.module"
                                              @getFileCount="getFileCount"
                                              :businessid="form1.whszzljsbId"
                                              :typeName="upload2.typeName"
                                              :editAble="upload2.editAble"
                                              :accept="upload2.accept"
                                              :isReturn="upload2.isReturn">

                    </attachment-single-module>
                  </el-row>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="印证材料" prop="yzcl">
                  <el-row v-if="isShow=='0504'" >
                    <attachment-single-module v-if="isShow=='0504'"
                                              @getFileCount="getFileCount"
                                              :module="upload3.module"
                                              :businessid="form1.whszzljsbId"
                                              :typeName="upload3.typeName"
                                              :editAble="upload3.editAble"
                                              :accept="upload3.accept"
                                              :isReturn="upload3.isReturn">
                    </attachment-single-module>
                  </el-row>
                </el-form-item>
              </el-col>
            </el-row>

          </el-form>
          <div style="margin-top: 20px;">
            <el-button type="primary" @click="submitForm1">确 定</el-button>
          </div>
        </el-row>

				<!--
				<el-row class="right-box-row" style="min-height: 430px;" v-show="isShow.substr(0, 2)=='04'">
					<el-row class="right-box-row-title">
						{{tableTitle}}
					</el-row>
					<el-form :model="queryParams" ref="queryForm" :inline="true" style="margin-top: 10px;">
						<el-row>

							<el-col :span="20">
								<el-input v-model="queryParams.entname" placeholder="请输入检索内容" clearable size="small"/>
							</el-col>

							<el-col :span="4">
								<el-button type="primary" size="small">检 索</el-button>
							</el-col>
						</el-row>
					</el-form>
					&lt;!&ndash; 质量奖 &ndash;&gt;
					<el-table v-loading="loading" :data="list" tooltip-effect="light" v-show="isShow=='0401'">
						<el-table-column label="序号" align="center" type="index" width="50" />
						<el-table-column align="center" prop="entname" label="获奖名称" width="100">
							<template slot-scope="scope">
								<el-tag>质量奖</el-tag>
							</template>
						</el-table-column>
						<el-table-column label="企业名称" align="center" prop="entname" width="360" />
						<el-table-column label="获奖年度" align="center" prop="entname">
							<template slot-scope="scope">
								2020
							</template>
						</el-table-column>
						<el-table-column label="所属地区" align="center" prop="county" />
					</el-table>
					&lt;!&ndash; 高端品牌培育企业 &ndash;&gt;
					<el-table v-loading="loading" :data="list" tooltip-effect="light" v-show="isShow=='0402'">
						<el-table-column label="序号" align="center" type="index" width="50" />
						<el-table-column align="center" prop="entname" label="行业类别" width="100">
							<template slot-scope="scope">
								<el-tag>制造业</el-tag>
							</template>
						</el-table-column>
						<el-table-column label="企业名称" align="center" prop="entname" width="360" />
						<el-table-column label="所属地区" align="center" prop="county" />

					</el-table>
					&lt;!&ndash; 认定优质基地 &ndash;&gt;
					<el-table v-loading="loading" :data="list" tooltip-effect="light" v-show="isShow=='0403'">
						<el-table-column label="序号" align="center" type="index" width="50" />
						<el-table-column label="所属地区" align="center" prop="county" width="100" />
						<el-table-column align="center" prop="jdmc" label="基地名称" width="200">
						</el-table-column>
						<el-table-column label="龙头骨干名称" align="center" prop="entname" width="200" >
							<template slot-scope="scope">
									威海市远洋捕捞公司<br>威海市船舶制造有限公司
								</template>
							</el-table-column>
						<el-table-column label="申报主体" align="center" prop="entname">
							<template slot-scope="scope">
								威海市高新技术产业协会
							</template>
						</el-table-column>
						<el-table-column label="获得创建称号年度" align="center" prop="entname">
							<template slot-scope="scope">
								2020
							</template>
						</el-table-column>
					</el-table>
					<pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum"
						:limit.sync="queryParams.pageSize" @pagination="getList" />
				</el-row>
				-->
			</el-col>
		</el-row>

	</div>
</template>

<script>
	import Clock from 'vue-clock2';
	import {listTzgg} from "@/api/zlts/zlppfw/tzgg";
	import {listZlj} from "@/api/zlts/zlppfw/zlj";
	import {listGdpy} from "@/api/zlts/zlppfw/gdpy";
	import {rdyzjdList} from "@/api/zlts/zlppfw/rdyzjd";
	import {cjyzjdList} from "@/api/zlts/zlppfw/cjyzjd";
	import {updatePvNum} from "@/api/itempv/pv";
  import Editor from "@/components/Editor/index.vue";
  import AttachmentSingleModule from "@/views/components/AttachmentSingleModule.vue";
  import {addWhqyggppsb} from "@/api/zlts/whqyggppsb/whqyggppsb";
  import {addWhszzljsb} from "@/api/zlts/whszzljsb/whszzljsb";
  import {getNewGuid} from "@/api/system/attachment";
  import {getFwjg} from "../../../../api/fwjg/fwjg";
  import {getTotal} from "../../../../api/qygzs";
  import {listLmgl} from "../../../../api/zlts/whqyggppsb/lmgl";
  import Treeselect from "@riophae/vue-treeselect";
  import "@riophae/vue-treeselect/dist/vue-treeselect.css";
  import {getMapData} from "../../../../api/TencentMap/map";

	export default {
    name: "Xwqycx",
    components: {
      AttachmentSingleModule, Editor,
      Clock,
      Treeselect
    },
    data() {
      return {
        lmglProps: {
          label: "lmName",
          value: "lmglId",
          key: "lmglId",
          children: "children",
          multiple: true
        },
        // 码上办-栏目管理表格数据
        lmglList: [],
        // 码上办-栏目管理树选项
        lmglOptions: [],
        upload1: {
          //是否上传
          editAble: true,
          //名称
          typeName: '短视频介绍(一分钟左右)',
          //附件类型
          module: 'whqyggppsb_video',
          //是否返回数量
          isReturn: false,
          accept: '.mp4'
        },
        upload2: {
          //是否上传
          editAble: true,
          //名称
          typeName: '申请表',
          //附件类型
          module: 'whszzljsb_sqtable',
          //是否返回数量
          isReturn: true,
          accept: '.doc,.docx,.pdf'
        },
        upload3: {
          //是否上传
          editAble: true,
          //名称
          typeName: '印证材料',
          //附件类型
          module: 'whszzljsb_yzcl',
          //是否返回数量
          isReturn: true,
          accept: '.doc,.docx,.pdf'
        },
        // 遮罩层
        loading: false,
        ppsbtzggLoading: false,
        zljLoading: false,
        gdpyLoading: false,
        rdyzjdLoading: false,
        cjyzjdLoading: false,
        // 总条数
        total: 12,
        ppsbtzggTotal: 0,
        zljTotal: 0,
        gdpyTotal: 0,
        rdyzjdTotal: 0,
        cjyzjdTotal: 0,
        // 是否显示弹出层
        open: false,
        // 查询参数
        time: undefined,
        menuIcon: 'menu-icon',
        menuIconDown: 'menu-icon-down',
        menuList: [{
          name: '品牌申报通知管理',
          labels: [{
            label: '品牌申报通知',
            url: 'zscqzhfw/flfgzc',
            code: "0101"
          }]
        },
          {
            name: '品牌展示',
            labels: [{
              label: '质量奖',
              url: 'zscqzhfw/flfgzc',
              code: "0401"
            }, {
              label: '省高端品牌培育企业',
              url: 'zscqzhfw/fwlmjj',
              code: "0402"
            }, {
              label: '认定省优质基地',
              url: 'zscqzhfw/zscqcs',
              code: "0403"
            }, {
              label: '创建省优质基地',
              url: 'zscqzhfw/zscqcs',
              code: "0404"
            }]
          },
          {
            name: '品牌申报',
            labels: [{
              label: '山东省品牌促进会',
              url: 'https://www.sdcbd.org.cn/',
              code: "0501"
            }, {
              label: '山东省质量评价协会',
              url: 'http://www.qel.com.cn/',
              code: "0502"
            },
              {
                label: '威海区域公共品牌',
                url: 'zscqzhfw/whqyggppsb',
                code: "0503"
              },
              {
                label: '威海市长质量奖',
                url: 'zscqzhfw/whszzljsb',
                code: "0504"
              }
            ]
          },
        ],
        isActive: "品牌申报通知管理",
        isActive2: "0101",
        isCollapse: "品牌申报通知管理",
        list: [],
        ppsbTzggList: [],
        zljList: [],
        gdpyList: [],
        rdyzjdList: [],
        cjyzjdList: [],
        queryParams: {
          pageNum: 1,
          pageSize: 10
        },
        ppsbtzggQueryParams: {
          pageNum: 1,
          pageSize: 10,
          title: undefined,
        },
        zljQueryParams: {
          pageNum: 1,
          pageSize: 10,
          zljName: undefined,
        },
        gdpyQueryParams: {
          pageNum: 1,
          pageSize: 10,
          zljName: undefined,
        },
        rdyzjdQueryParams: {
          pageNum: 1,
          pageSize: 10,
          ltggEntname: undefined,
        },
        cjyzjdQueryParams: {
          pageNum: 1,
          pageSize: 10,
          zljName: undefined,
        },
        tableTitle: "品牌申报通知管理查询",
        isShow: '0101',
        formsb: {
          name: '',
          iscn: false,
          date1: '',
          date2: '',
          delivery: false,
          type: [],
          resource: '',
          desc: ''
        },
        types: [],
        // 表单参数
        form: {
          whqyggppsbId: null,
          entProductInstoduction: null,
          onlineAddress: null,
          offlineAddress: null,
          photoPath: null,
          videoPath: null,
          linkUser: null,
          linkWay: null,
          auditStatus: null,
          auditOpinion: null,
          createBy: null,
          createTime: null,
          updateBy: null,
          updateTime: null,
          selectList: [],
        },
        // 表单校验
        rules: {
          entProductInstoduction: [
            {required: true, message: "企业和产品图文介绍不能为空", trigger: "blur"}
          ],
          onlineAddress: [
          ],
          offlineAddress: [
            {required: true, message: "线下商城地址不能为空", trigger: "blur"}
          ],
          photoPath: [
            {required: true, message: "产品不能为空", trigger: "blur"}
          ],
          videoPath: [
            {required: true, message: "短视频介绍不能为空", trigger: "blur"}
          ],
          linkUser: [
            {required: true, message: "联系人不能为空", trigger: "blur"}
          ],
          linkWay: [
            {required: true, message: "联系方式不能为空", trigger: "blur"}
          ],
          selectList: [
            {
              required: true, message: "请选择申报产品(服务)类别", trigger: "blur"
            }
          ]
        },
        rules1: {
          linkUser: [
            {required: true, message: "联系人不能为空", trigger: "blur"}
          ],
          linkWay: [
            {required: true, message: "联系方式不能为空", trigger: "blur"}
          ],
          sqType: [
            {required: true, message: "申请类型不能为空", trigger: "blur"}
          ],
          region: [
            {required: true, message: "所属区市不能为空", trigger: "blur"}
          ],
          sqName: [
            {required: true, message: "申请人/企业名称不能为空", trigger: "blur"}
          ],
          yzcl: [
              {required: true, message: "印证材料不能为空", trigger: "blur"}
          ],
          sqTable: [
              {required: true, message: "申请表不能为空", trigger: "blur"}
          ]
        },
        // 表单参数
        form1: {
          whszzljsbId: null,
          sqName: null,
          region: null,
          sqType: null,
          linkUser: null,
          linkWay: null,
          auditStatus: null,
          auditOpinion: null,
          createBy: null,
          createTime: null,
          updateBy: null,
          updateTime: null,
          sqTable: null,
          yzcl: null,
        },
        // 字典数据
        sbTypeList: [],
        ssqsList: []
      };
    },
    created() {
      this.getDicts("cjyzjd_type").then(response => {
        this.types = response.data;
      });
      this.getDicts("yw_msb_whszzljsb_type").then(response => {
        this.sbTypeList = response.data;
      });
      this.getDicts("yw_msb_whszzljsb_ssqs").then(response => {
        this.ssqsList = response.data;
      });
      this.getPpsbtzggList();
    },
    methods: {
      changeMenu(name, code) {
        this.isCollapse = name;
        this.isActive = name;
        this.isActive2 = undefined;
      },
      changeMenu2(name, code, name2, url) {
        this.isActive = name;
        this.isActive2 = code;
        /*if (code === '0201') {
					window.open("http://cx.cnca.cn/CertECloud/institutionBody/authenticetionList");
				} else if (code === '0301') {
					window.open("http://amr.shandong.gov.cn/col/col92838/index.html");
				} else */
        if (code === '0101') {
          this.getPpsbtzggList();
          this.isShow = code;
          this.tableTitle = name + "查询";
          updatePvNum("zlts_zljpp_ppsbtzglcx").then(response => {
            //pv 点击品牌申报通知管理查询
          });
        } else if (code === '0401') {
          this.getZljList();
          this.isShow = code;
          this.tableTitle = name + "-" + name2;
          updatePvNum("zlts_zljpp_gscpjgzlj").then(response => {
            //pv 点击公示测评结果-质量奖
          });
        } else if (code === '0402') {
          this.getGdpyList();
          this.isShow = code;
          this.tableTitle = name + "-" + name2;
          updatePvNum("zlts_zljpp_gscpjggdpppyqy").then(response => {
            //pv 点击公示测评结果-高端品牌培育企业
          });
        } else if (code === '0403') {
          this.getRdyzjdList();
          this.isShow = code;
          this.tableTitle = name + "-" + name2;
          updatePvNum("zlts_zljpp_gscpjgrdyzjd").then(response => {
            //pv 点击公示测评结果-认定优质基地
          });
        } else if (code === '0404') {
          this.getCjyzjdList();
          this.isShow = code;
          this.tableTitle = name + "-" + name2;
          updatePvNum("zlts_zljpp_gscpjgcjyzjd").then(response => {
            //pv 点击公示测评结果-创建优质基地
          });
        } else if (code === '0501') {
          window.open(url)
        } else if (code === '0502') {
          window.open(url)
        } else if (code == '0503') {
          //生成附件id
          getNewGuid().then(response => {
            this.checkLoginUser(this.form);
            this.getTreeselect();
            this.form.videoPath = response.data.businessid;
            this.form.whqyggppsbId = response.data.businessid;
            this.isShow = code;
            this.tableTitle = name + "-" + name2;
          })
        } else if (code == '0504'){
          getNewGuid().then(res => {
            this.checkLoginUser(this.form1);
            this.isShow = code;
            this.form1.whszzljsbId = res.data.businessid;
            this.tableTitle = name + "-" + name2;
          })
        }
      },
    /*getList() {
				this.list = [{
						entname: "威海本臻力行检验检测技术服务有限公司",
						uniscid: "91370212MA3C4AG391",
						type: "资质认定检验检测机构",
						product: "环境检测",
						licname: "产品质量检验检测许可证-XK202109382341",
						linkman: "王洗",
						linktel: "189899873",
						county: '环翠区',
						jdmc: '威海市环翠区创建山东省优质工艺家纺品生产基地'
					},
					{
						entname: "威海本臻力行检验检测技术服务有限公司",
						uniscid: "91370212MA3C4AG391",
						type: "资质认定检验检测机构",
						product: "环境检测",
						licname: "产品质量检验检测许可证-XK202109382341",
						linkman: "王洗",
						linktel: "189899873",
						county: '经开区',
						jdmc: '威海市经开区创建山东省优质冷冻调理食品生产基地'
					},
					{
						entname: "威海本臻力行检验检测技术服务有限公司",
						uniscid: "91370212MA3C4AG391",
						type: "资质认定检验检测机构",
						product: "环境检测",
						licname: "产品质量检验检测许可证-XK202109382341",
						linkman: "王洗",
						linktel: "189899873",
						county: '荣成市',
						jdmc: '威海市荣成市创建山东省优质船舶制造生产基地'
					},
					{
						entname: "威海本臻力行检验检测技术服务有限公司",
						uniscid: "91370212MA3C4AG391",
						type: "资质认定检验检测机构",
						product: "环境检测",
						licname: "产品质量检验检测许可证-XK202109382341",
						linkman: "王洗",
						linktel: "189899873",
						county: '文登区',
						jdmc: '威海市文登区创建山东省优质速食食品生产基地'
					},
					{
						entname: "威海本臻力行检验检测技术服务有限公司",
						uniscid: "91370212MA3C4AG391",
						type: "资质认定检验检测机构",
						product: "环境检测",
						licname: "产品质量检验检测许可证-XK202109382341",
						linkman: "王洗",
						linktel: "189899873",
						county: '经开区',
						jdmc: '威海市经开区创建山东省优质冷冻调理食品生产基地'
					},
					{
						entname: "威海本臻力行检验检测技术服务有限公司",
						uniscid: "91370212MA3C4AG391",
						type: "资质认定检验检测机构",
						product: "环境检测",
						licname: "产品质量检验检测许可证-XK202109382341",
						linkman: "王洗",
						linktel: "189899873",
						county: '环翠区'
					},
					{
						entname: "威海本臻力行检验检测技术服务有限公司",
						uniscid: "91370212MA3C4AG391",
						type: "资质认定检验检测机构",
						product: "环境检测",
						licname: "产品质量检验检测许可证-XK202109382341",
						linkman: "王洗",
						linktel: "189899873",
						county: '环翠区',
						jdmc: '威海市环翠区创建山东省优质工艺家纺品生产基地'
					},
				];
				this.total = this.list.length;
			},*/
    //查询品牌申报通知公告
    getPpsbtzggList() {
      this.ppsbtzggLoading = true;
      listTzgg(this.ppsbtzggQueryParams).then(response => {
        this.ppsbTzggList = response.rows;
        this.ppsbtzggTotal = response.total;
        this.ppsbtzggLoading = false;
      });
      /*
				this.list = [{
						title: "■ 市场监管总局办公厅关于开展第四届中国质量奖评选表彰工作的通知",
						fbdate: "2021-10-27",
					},
					{
						title: "■ 公示！第八届山东省省长质量奖拟获奖名单",
						fbdate: "2021-10-27",
					},
					{
						title: "■ 2021年度山东省高端品牌新增培育企业名单",
						fbdate: "2021-10-27",
					},
					{
						title: "■ 2021年山东省区域品牌发展指数发布 12市发展指数超过70",
						fbdate: "2021-10-27",
					},
					{
						title: "■ 品牌领域新发布6项重要国家标准",
						fbdate: "2021-10-27",
					}
				];
				this.total = this.list.length;
				*/
    },
    //查询质量奖
    getZljList() {
      this.zljLoading = true;
      listZlj(this.queryParams).then(response => {
        this.zljList = response.rows;
        this.zljTotal = response.total;
        this.zljLoading = false;
      });
    },
    //查询高端培育
    getGdpyList() {
      this.gdpyLoading = true;
      listGdpy(this.gdpyQueryParams).then(response => {
        this.gdpyList = response.rows;
        this.gdpyTotal = response.total;
        this.gdpyLoading = false;
      });
    },
    typeFormat(value) {
      return this.selectDictLabel(this.types, value);
    },
    //查询认定优质基地
    getRdyzjdList() {
      this.rdyzjdLoading = true;
      rdyzjdList(this.rdyzjdQueryParams).then(response => {
        this.rdyzjdList = response.rows;
        this.rdyzjdTotal = response.total;
        this.rdyzjdLoading = false;
      });
    },
    //查询创建优质基地
    getCjyzjdList() {
      this.cjyzjdLoading = true;
      cjyzjdList(this.cjyzjdQueryParams).then(response => {
        this.cjyzjdList = response.rows;
        this.cjyzjdTotal = response.total;
        this.cjyzjdLoading = false;
      });
    },
    openPpsbTzggDetail(item) {
      this.utils.windowOpen('/main/zltszhfw/zlypp/detail' + '/' + item.recid);
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          // 将this.form.selectList中的数组转成字符串
          this.form.selectList = this.form.selectList.map(item => {
            return item.toString();
          });
          console.log(this.form.selectList)
          addWhqyggppsb(this.form).then(response => {
            this.msgSuccess("新增成功");
            this.form.offlineAddress = null;
            this.form.onlineAddress = null;
            this.form.photoPath = null;
            this.form.entProductInstoduction = null;
            this.form.selectList = []
          });
          getNewGuid().then(res => {
            this.form.videoPath = res.data.businessid;
            this.form.whqyggppsbId = res.data.businessid;
          })
        }
      });
    },
    /** 提交按钮 */
    submitForm1() {
      this.$refs["form1"].validate(valid => {
        if (valid) {
          addWhszzljsb(this.form1).then(response => {
            this.msgSuccess("新增成功");
            this.form1.yzcl = null;
            this.form1.sqTable = null;
          });
          getNewGuid().then(res => {
            this.form1.whszzljsbId = res.data.businessid;
          })
        }
      });
    },
      login() {
        // this.islogin=true;
        let url =
            "https://zwfw.sd.gov.cn/JIS/front/login.do?uuid=9HOFE5P1Gznq&redirectUrl=https://zhjg.weihai.cn/api/tydlGetTicket";
        window.location.href = url;
      },
    checkLoginUser(data) {
      // let ssessionLoginUser = {
      //   "token": "8c0ea4d4dc7a681ec6e9c068f92729ed",
      //   "loginTime": 1743064817710,
      //   "expireTime": 1743066617710,
      //   "ipaddr": null,
      //   "loginLocation": null,
      //   "browser": null,
      //   "os": null,
      //   "permissions": null,
      //   "user": {
      //     "uuid": "142767912",
      //     "realName": "孙平",
      //     "isauthuser": "1",
      //     "cartType": "111",
      //     "cartId": "370633197012261327",
      //     "tel": "13001658539",
      //     "ftype": "2",
      //     "corname": "威海顺通会计服务有限公司",
      //     "cornumber": "91371000MA95018D8K",
      //     "state": 0,
      //     "isBlackList": "N",
      //     "isWhEnt": "Y",
      //     "finishedInfo": "Y",
      //     "county": "371020",
      //     "countyCh": "高区",
      //     "ywFwjgRecid": "7446522257fa445fb8d52fa7b93b1595"
      //   },
      //   "ywFwjg": {
      //     "recid": "7446522257fa445fb8d52fa7b93b1595",
      //     "pripid": "3710000000220210924BTTFG",
      //     "name": "威海顺通会计服务有限公司",
      //     "uniscid": "91371000MA95018D8K",
      //     "dom": "乳山市大孤山镇吴家沟村",
      //     "llr": "李四666",
      //     "llrtel": "15311432453",
      //     "llrphone": "86237928",
      //     "type": "00350087310f439daa96aa3025a6c06d",
      //     "fwlmStatus": "1",
      //     "shStatus": "2",
      //     "zcTime": null,
      //     "deleteStatus": "N",
      //     "synopsis": "asdfdsaf",
      //     "website": null,
      //     "createBy": null,
      //     "createTime": "2021-11-20 00:00:00",
      //     "updateBy": "孔霞",
      //     "updateTime": "2023-02-09 00:00:00",
      //     "zcsjStartTime": null,
      //     "zcsjEntTime": null,
      //     "cxReason": null,
      //     "userType": "2",
      //     "loginName": "威海顺通会计服务有限公司",
      //     "uuid": "142767912",
      //     "lastLoginTime": null,
      //     "isBlack": "N",
      //     "loginStatus": "1",
      //     "loginTime": 1743064817759,
      //     "county": "371020",
      //     "countyCh": "高区",
      //     "deptId": 51,
      //     "deptCode": "37100031",
      //     "cardType": null,
      //     "cardNumber": null,
      //     "entcat": "1",
      //     "isFinishEdInfo": null,
      //     "opIdea": null,
      //     "ywAuditStatus": "4",
      //     "ywSaveStatus": "Y",
      //     "ywDelStatus": "N"
      //   },
      //   "enabled": true,
      //   "islogin": true
      // }
      let ssessionLogin = JSON.parse(localStorage.getItem('ssessionLoginUser'));
      // let ssessionLogin = ssessionLoginUser
      if(ssessionLogin === null || ssessionLogin === undefined){
        this.login();
        return false;
      }
      data.region = ssessionLogin.ywFwjg.countyCh;
      data.linkUser = ssessionLogin.ywFwjg.llr;
      data.linkWay = ssessionLogin.ywFwjg.llrtel;
      data.sqName = ssessionLogin.ywFwjg.name;
      data.sqType = (parseInt(ssessionLogin.ywFwjg.userType) -1).toString();
      // console.log("qygzs index   ssessionLoginUser==",ssessionLogin);
      this.entname = ssessionLogin.ywFwjg.name || ssessionLogin.user.corname;
      // console.log("user==>",ssessionLogin.user);
      // console.log("ywFwjg==>", ssessionLogin.ywFwjg);
      this.uniscid = ssessionLogin.ywFwjg.uniscid;
      this.pripid = ssessionLogin.ywFwjg.pripid;
      this.ftype = ssessionLogin.user.ftype;
      this.entcat = ssessionLogin.ywFwjg.entcat;
      getFwjg(ssessionLogin.ywFwjg.recid).then(response => {
        // debugger
        let ywFwjgObj = response.data;
        let userType = ywFwjgObj.userType;//用户类型
        // debugger
        if (userType === '1') {
          //个人
          if (ywFwjgObj.llrtel === null || ywFwjgObj.llrtel === '' || ywFwjgObj.llrtel === undefined) {
            this.isQyxxWS = false;
          } else if (ywFwjgObj.county === null || ywFwjgObj.county === '' || ywFwjgObj.county === undefined) {
            this.isQyxxWS = false;
          } else {
            this.isQyxxWS = true;
            this.currentView = 'wsgrxx';
          }
        } else {
          //企业用户
          if (ywFwjgObj.type === null || ywFwjgObj.type === '' || ywFwjgObj.type === undefined) {
            this.isQyxxWS = false;
          } else if (ywFwjgObj.county === null || ywFwjgObj.county === '' || ywFwjgObj.county === undefined) {
            this.isQyxxWS = false;
          } else {
            this.isQyxxWS = true;
            this.currentView = 'QydjJbxx';
            if (ywFwjgObj.entcat === '2') {//如果当前用户是个体，显示个体基础信息
              this.currentView = 'GtdjJbxx';
            }
          }
        }
      });
      //是否已经完善企业信息
      // console.log("1111111111111",ssessionLogin.ywFwjg);
      // this.isQyxxWS = this.isEmptyStr(ssessionLogin.ywFwjg.type) ? false : true;
      // //已经完善了企业信息
      // if (this.isQyxxWS && this.ftype==='2') {
      // 	//默认显示企业基础信息
      // 	this.currentView = 'QydjJbxx';
      // 	if (this.entcat === '2')//如果当前用户是个体，显示个体基础信息
      // 		this.currentView = 'GtdjJbxx';
      // }else if (this.isQyxxWS && this.ftype==='1'){
      // 	this.currentView = 'wsgrxx';
      // }
      if (this.ftype === '1') {
        this.realName = '个人用户';
        this.isJbxx = false;
        //个人用户，企业完善信息不显示
        // this.isQyxxWS = true;
        this.activeCode = '';
        this.currentView = 'wsgrxx';

      } else {
        this.realName = '企业用户';
        // console.log("num*****==>", ssessionLogin.user);
        getTotal(ssessionLogin.user.ywFwjgRecid).then(response => {
          this.zlzrnum = response.zlzrfb;
          this.rzfwcpnum = response.xwqyrzsq;
          this.zpxxnum = response.qyzpxx;
          this.ywzxnum = response.zxzx;
          this.ywsqnum = response.sqsb;
          this.yscnum = response.sc;
          this.drxxnum = response.nowSms;
          this.flfgzcnum = response.flfg;
          this.drtsznnum = response.bszn;

        });
      }

    },
      /** 转换码上办-栏目管理数据结构 */
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.lmglId,
          label: node.lmName,
          children: node.children
        };
      },
      /** 查询码上办-栏目管理下拉树结构 */
      async getTreeselect() {
        await listLmgl().then(response => {
          this.lmglOptions = [];
          this.lmDict = response.data;
        });
        var data = await this.handleTreeNoRootNode(this.lmDict, "lmglId", "preid");
        for(let i=0;i<data.length;i++){
          await this.removeEmptyChildren(data[i]);
        }
        // 删除data中的children为空的属性
        this.lmglOptions = data;
      },
      removeEmptyChildren(node) {
        if (node.children && node.children.length === 0) {
          delete node.children;
        } else if (node.children) {
          node.children.forEach(child => this.removeEmptyChildren(child));
        }
      },
      async querySearch(queryString, cb) {
        if (queryString == "") {
          cb([]);
          return;
        }else{
          await new Promise(resolve => setTimeout(resolve, 3000));
          let res = await this.$jsonp(
              `https://apis.map.qq.com/ws/place/v1/suggestion/`,
              {
                region: '威海',
                keyword: queryString,
                key: "IQXBZ-53L3N-OVKFZ-SNVDQ-YFR7K-62F6Q", // 你的key
                type: 1,
                output: "jsonp",
              }
          );
          console.log("res==>",res)
          let result = res.data.map(item => {
            return {
              value: item.address,
              label: item.address
            };
          });
          // 调用 callback 返回建议列表的数据
          cb(result);
        }
      },
      handleSelect(item) {
      },
      getFileCount(val) {
        if(val.count == 0) {
          return false;
        }
        if(val.module == this.upload2.module){
          this.form1.sqTable = val.count
        }
        if(val.module == this.upload3.module){
          this.form1.yzcl = val.count
         }

      }
  }
	}
</script>

<style scoped>
	.content-wapper{
		margin-top: 5px;
		padding: 10px;
	}
	.navigation{
		padding:20px 15px;
		line-height: 20px;
		height: 60px;
		background-color: #F5F5F5;
		margin-bottom: 15px;
	}

	.left-img img {
		width: 100%;
	}

	.menu-box {
		background-color: #FAFAFA;
		padding: 15px 10px;
	}

	.el-collapse-item {
		background-color: #1482F0;
	}

	.menu-level1 {
		padding: 10px;
		background-color: #eeeeee;
		padding-left: 20px;
		font-size: 15px;
		text-align: left;
		margin-bottom: 10px;
		margin-top: 10px;
		cursor: pointer;
		font-weight: 500;
		font-family: "arial black";
	}

	.active1 {
		color: #55aaff;
		background-color: rgb(235, 239, 248);
	}

	.menu-icon {
		float: right;
		 
	}
	.menu-icon-down {
		float: right;
		transform: rotate(90deg);
	}
	.menu-level2 {
		padding: 5px 20px 5px 20px;
		font-size: 12px;
		font-weight: 500;
		cursor: pointer;
	}

	.active2 {
		color: rgb(255, 208, 75);
	}

	.right-box {
		padding-left: 10px;
	}

	.right-box-row {
		border: 1px solid #cccccc;
		padding: 0px 15px 0;
	}

	.right-box-row-title {
		padding: 15px 0;
		text-align: left;
		color: #409eff;
		font-size: 18px;
		font-weight: bold;
		border-bottom: 1px solid #cccccc;
		margin: 0px 0;
	}

	/deep/.title:hover {
		color: #1482f0;
		cursor: pointer;
	}

	.el-table .cell {
		white-space: pre-line
	}
</style>
